export const oldSiteRouteNames = {
  print: '/print/:productSlug',
  product: '/product/:productSlug',
  shopPrints: '/shop/print',
  shopStickers: '/shop/sticker',
  shopTees: '/shop',
};
